import { ImportantEventId, JournalId } from 'types';

export const IMPORTANT_EVENTS = (journalId: JournalId) =>
    `/api/v1/journals/${journalId}/important-events`;
export const IMPORTANT_EVENT = (journalId: JournalId, importantEventId: ImportantEventId) =>
    `/api/v1/journals/${journalId}/important-events/${importantEventId}`;
